// -*- Mode: rjsx -*-
import React, { useState } from 'react';

import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from 'react-loading-skeleton';
import Tooltip from '@mui/material/Tooltip';

function AdminDetail(props) {
    let value = props.value !== undefined ? (props.valueElement || props.value) : <Skeleton />;
    let label = props.label !== undefined ? props.label : <Skeleton />;
    let icon = props.icon !== undefined ? props.icon : <Skeleton />;

    let secondaryAction = null;
    if (props.secondaryAction) {
        secondaryAction = (
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                aria-label="comments"
                onClick={props.secondaryAction}
                size="large">
                { props.value ? props.secondaryActionIcon : <Skeleton height={16} width={16} /> }
              </IconButton>
            </ListItemSecondaryAction>
        );
    }
        
    
    return (
        <Tooltip title={props.tooltip || ''} arrow={true} >
          <ListItem>
            <ListItemIcon> {icon} </ListItemIcon>
            <ListItemText primary={value || "--"} secondary={label} />
            { secondaryAction }
          </ListItem>
        </Tooltip>
    );
}

export default AdminDetail;
